var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUrgency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#EEF6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3419 24.49L28.3419 22.83C28.1319 22.46 27.9419 21.76 27.9419 21.35V18.82C27.9419 16.47 26.5619 14.44 24.5719 13.49C24.0519 12.57 23.0919 12 21.9919 12C20.9019 12 19.9219 12.59 19.4019 13.52C17.4519 14.49 16.1019 16.5 16.1019 18.82V21.35C16.1019 21.76 15.9119 22.46 15.7019 22.82L14.6919 24.49C14.2919 25.16 14.2019 25.9 14.4519 26.58C14.6919 27.25 15.2619 27.77 16.0019 28.02C17.9419 28.68 19.9819 29 22.0219 29C24.0619 29 26.1019 28.68 28.0419 28.03C28.7419 27.8 29.2819 27.27 29.5419 26.58C29.8019 25.89 29.7319 25.13 29.3419 24.49Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8297 30.01C24.4097 31.17 23.2997 32 21.9997 32C21.2097 32 20.4297 31.68 19.8797 31.11C19.5597 30.81 19.3197 30.41 19.1797 30C19.3097 30.02 19.4397 30.03 19.5797 30.05C19.8097 30.08 20.0497 30.11 20.2897 30.13C20.8597 30.18 21.4397 30.21 22.0197 30.21C22.5897 30.21 23.1597 30.18 23.7197 30.13C23.9297 30.11 24.1397 30.1 24.3397 30.07C24.4997 30.05 24.6597 30.03 24.8297 30.01Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgency);
export default __webpack_public_path__ + "static/media/urgency.ccddf521.svg";
export { ForwardRef as ReactComponent };